import React from 'react';
import { IconButton, IconButtonProps } from '@chakra-ui/react';

type Props = {
  icon: React.ReactElement;
};

const ButtonCircle = React.forwardRef<HTMLButtonElement, Props & IconButtonProps>(
  ({ icon, ...args }, ref) => (
    <IconButton
      size="sm"
      background="livelinx.purple50"
      color="livelinx.grey200"
      borderRadius="50%"
      border="none"
      icon={icon}
      ref={ref} // Forwarding the ref here
      {...args}
    />
  )
);

ButtonCircle.displayName = 'ButtonCircle'; // Set displayName for better debugging

export default ButtonCircle;
